import React from 'react';
import { render } from 'react-dom';
import App from './containers/App/App';
import {configureAmplify} from './services';


configureAmplify();
render(
  <App />,
  document.getElementById('root'),
);
